module.exports = __webpack_public_path__ + "img/16l009-02.3079fd7c.png";